"use strict";

var _classCallCheck = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _inherits = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _createSuper = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createSuper");

var EventImpl = require("./Event-impl").implementation;

var ProgressEventInit = require("../generated/ProgressEventInit");

var ProgressEventImpl = /*#__PURE__*/function (_EventImpl) {
  _inherits(ProgressEventImpl, _EventImpl);

  var _super = _createSuper(ProgressEventImpl);

  function ProgressEventImpl() {
    _classCallCheck(this, ProgressEventImpl);

    return _super.apply(this, arguments);
  }

  return ProgressEventImpl;
}(EventImpl);

ProgressEventImpl.defaultInit = ProgressEventInit.convert(undefined);
module.exports = {
  implementation: ProgressEventImpl
};